import React from 'react'
import "./index.css"
import Header from '../Header'
import { Container } from 'react-bootstrap'
import CarousalComponent from '../CarousalComponent/CarousalComponent'
import RestaurantsList from '../RestaurantsList/RestaurantsList'
import Footer from '../Footer/footer'


function Home() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <Header />
            <Container className='home-container'>
                <CarousalComponent />
                <RestaurantsList />
                <Footer />
                {/* <img src={"/images/Footer.png"} /> */}
            </Container>
        </>
    )
}

export default Home
// export class Home extends Component {

//     buyCake = () => {
//         this.props.buyCake()
//     }

//     componentDidMount() {
//         this.getRestaurants()
//     }

//     getRestaurants = () => {
//         this.props.fetchRestaurantsList()
//     }

//     render() {
//         console.log("state", this.props)
//         return (
//             <>
//                 <Header />

//                 <Container className='home-container'>
//                     {/* <div >
//                         <img src="/images/Swiggy_Clone_1.jpg" />
//                     </div> */}
//                     <Carousel fade>
//                         <Carousel.Item interval={1000}>
//                             <img className='home-caurosal-images' src="/images/caurosal1.jpg" />
//                             <Carousel.Caption>
//                                 <h3>Non Veg Pizza</h3>
//                                 <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
//                             </Carousel.Caption>
//                         </Carousel.Item>
//                         <Carousel.Item interval={1000}>
//                             <img className='home-caurosal-images' src="/images/caurosal2.jpg" />
//                             <Carousel.Caption>
//                                 <h3>Spicy Pizza</h3>
//                                 <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
//                             </Carousel.Caption>
//                         </Carousel.Item>
//                         <Carousel.Item>
//                             <img className='home-caurosal-images' src="/images/caurosal3.jpg" />
//                             <Carousel.Caption>
//                                 <h3>Chicken Combo Pack</h3>
//                                 <p>
//                                     Praesent commodo cursus magna, vel scelerisque nisl consectetur.
//                                 </p>
//                             </Carousel.Caption>
//                         </Carousel.Item>
//                     </Carousel>

//                     <p>Restaurants List</p>
//                 </Container>
//             </>
//         )
//     }
// }

// const mapStateToProps = (state) => {
//     return {
//     }
// }

// const mapDispatchToProps = (dispatch) => {
//     return {
//         getRestaurantsList: () => dispatch(fetchRestaurants())
//     }
// }



// export default connect(mapStateToProps, mapDispatchToProps)(Home)
